var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotiP1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 336671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 364",
    filter: "url(#filter0_d_14328_57469)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 32.5,
    r: 22.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3572 25.8608C34.3572 25.3854 33.9734 25 33.5 25C33.0266 25 32.6428 25.3854 32.6428 25.8608V26.5063H32.165C30.2578 26.5063 28.6793 27.9955 28.5602 29.907L28.3708 32.9484C28.2985 34.108 27.9109 35.2255 27.2499 36.1792C26.6528 37.0408 27.1844 38.2309 28.2224 38.356L31.1428 38.7079V39.6329C31.1428 40.9402 32.1982 42 33.5 42C34.8018 42 35.8572 40.9402 35.8572 39.6329V38.7079L38.7776 38.356C39.8156 38.2309 40.3472 37.0408 39.7501 36.1792C39.0891 35.2255 38.7015 34.108 38.6292 32.9484L38.4398 29.907C38.3207 27.9955 36.7422 26.5063 34.835 26.5063H34.3572V25.8608ZM32.4286 39.6329C32.4286 40.2271 32.9083 40.7089 33.5 40.7089C34.0917 40.7089 34.5715 40.2271 34.5715 39.6329V38.9873H32.4286V39.6329Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 323",
    cx: 41,
    cy: 32,
    r: 4,
    fill: "#EBB542"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14328_57469",
    x: 0,
    y: 0,
    width: 67,
    height: 67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14328_57469"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14328_57469",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiP1);
export default __webpack_public_path__ + "static/media/noti_p1.2fd3221c044e85c139e69a1b9ad5680f.svg";
export { ForwardRef as ReactComponent };